'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var React = require('react');
var hooks_preventEventPropagation = require('./hooks/prevent-event-propagation/index.js');
var iconButtons = require('./icon-buttons-442762e4.js');
var iconLibrary_systemIcons_microIcons_question = require('./icon-library/system-icons/micro-icons/question/index.js');
var tooltip = require('./tooltip-e34b5863.js');
var element = require('./element-2d0b0a9a.js');
var styled = require('styled-components');
var focusVisibleSelector = require('./focus-visible-selector-7139d43f.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var TextStyle = styled__default['default'].span(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  border-bottom: ", ";\n  color: ", ";\n  padding: ", ";\n  box-sizing: border-box;\n  &:hover {\n    background: ", ";\n    border-radius: ", ";\n  }\n  &", " {\n    border: ", ";\n    border-radius: ", ";\n    padding: 0;\n    outline: none;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return "1px dashed ".concat(theme.underlineTooltipTriggerTheme.underlineColor);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.underlineTooltipTriggerTheme.fontColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "0 ".concat(theme.spacing(theme.underlineTooltipTriggerTheme.focusSpacingMultiplier), "px");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.underlineTooltipTriggerTheme.backgroundColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.underlineTooltipTriggerTheme.backgroundRadius, " ").concat(theme.underlineTooltipTriggerTheme.backgroundRadius, " 0 0");
}, focusVisibleSelector.focusVisibleSelectorMixin, function (_ref6) {
  var theme = _ref6.theme;
  return "2px solid ".concat(theme.underlineTooltipTriggerTheme.focusColor);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.underlineTooltipTriggerTheme.focusRadius;
});
var IconTooltipTriggerStyle = styled__default['default'].span(_templateObject2 || (_templateObject2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  color: ", ";\n  padding: ", ";\n  box-sizing: border-box;\n  display: inline-block;\n  &", " {\n    border: ", ";\n    border-radius: ", ";\n    padding: 0;\n    outline: none;\n  }\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.iconTooltipTriggerTheme.fontColor;
}, function (_ref9) {
  var theme = _ref9.theme;
  return "".concat(theme.spacing(theme.iconTooltipTriggerTheme.focusSpacingMultiplier), "px");
}, focusVisibleSelector.focusVisibleSelectorMixin, function (_ref10) {
  var theme = _ref10.theme;
  return "2px solid ".concat(theme.iconTooltipTriggerTheme.focusColor);
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.iconTooltipTriggerTheme.focusRadius;
});
var IconStyle = styled__default['default'].div(_templateObject3 || (_templateObject3 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  margin-left: ", ";\n  margin-right: ", ";\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 1;\n"])), function (_ref12) {
  var iconPosition = _ref12.iconPosition,
    theme = _ref12.theme;
  return "".concat(iconPosition !== 'left' ? theme.spacing(1) + 'px' : '');
}, function (_ref13) {
  var iconPosition = _ref13.iconPosition,
    theme = _ref13.theme;
  return "".concat(iconPosition === 'left' ? theme.spacing(1) + 'px' : '');
});
var IconTextStyle = styled__default['default'].div(_templateObject4 || (_templateObject4 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n"])));

/**
 * This component should be wrapped in the OwnUpTooltip component, in order for the tooltip
 *   to trigger.
 */
// eslint-disable-next-line react/display-name
var OwnUpUnderlineTooltipTrigger = /*#__PURE__*/React__default['default'].forwardRef(function (props, ref) {
  var handleOnMouseDown = React.useCallback(function (event) {
    hooks_preventEventPropagation.preventEventPropagation(event);
  }, []);
  return /*#__PURE__*/React__default['default'].createElement(TextStyle, _rollupPluginBabelHelpers._extends({
    onMouseDown: handleOnMouseDown,
    tabIndex: 0,
    ref: ref
  }, props), props.children);
});

/**
 * This component should be wrapped in the OwnUpTooltip component, in order for the tooltip
 *   to trigger. This tooltip trigger contains an icon.
 */

var OwnUpIconTooltipTriggerImpl = function OwnUpIconTooltipTriggerImpl(props) {
  var icon = props.icon,
    iconPosition = props.iconPosition,
    children = props.children,
    tooltipTitle = props.tooltipTitle,
    description = props.description,
    tooltipPlacement = props.tooltipPlacement,
    additionalTooltipProps = props.additionalTooltipProps;
  var handleOnMouseDown = React.useCallback(function (event) {
    hooks_preventEventPropagation.preventEventPropagation(event);
  }, []);
  var styledIcon = /*#__PURE__*/React__default['default'].createElement(IconStyle, props, icon);
  return /*#__PURE__*/React__default['default'].createElement(IconTooltipTriggerStyle, _rollupPluginBabelHelpers._extends({
    tabIndex: 0
  }, props, {
    onMouseDown: handleOnMouseDown
  }), iconPosition === 'left' && /*#__PURE__*/React__default['default'].createElement(tooltip.OwnUpTooltip, _rollupPluginBabelHelpers._extends({
    tooltipTitle: tooltipTitle,
    description: description,
    placement: tooltipPlacement
  }, additionalTooltipProps), styledIcon), /*#__PURE__*/React__default['default'].createElement(IconTextStyle, null, children), iconPosition !== 'left' && /*#__PURE__*/React__default['default'].createElement(tooltip.OwnUpTooltip, _rollupPluginBabelHelpers._extends({
    tooltipTitle: tooltipTitle,
    description: description,
    placement: tooltipPlacement
  }, additionalTooltipProps), styledIcon));
};
var largeIcon = /*#__PURE__*/React__default['default'].createElement(iconButtons.OwnUpIconButton, {
  icon: iconLibrary_systemIcons_microIcons_question.MicroQuestionIcon,
  name: "Tooltip",
  "aria-label": 'tooltip',
  size: 1.25,
  title: "" // Do not use the name for the title attribute on the base element (button).
});
var smallIcon = /*#__PURE__*/React__default['default'].createElement(iconButtons.OwnUpIconButton, {
  icon: iconLibrary_systemIcons_microIcons_question.MicroQuestionIcon,
  name: "Tooltip",
  "aria-label": 'tooltip',
  size: 1.125,
  title: "" // Do not use the name for the title attribute on the base element (button).
});
var OwnUpIconTooltipTriggerBodyMedium = function OwnUpIconTooltipTriggerBodyMedium(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpIconTooltipTriggerImpl, _rollupPluginBabelHelpers._extends({}, props, {
    icon: largeIcon
  }), /*#__PURE__*/React__default['default'].createElement(element.OwnUpBodyMedium, {
    variant: "body1"
  }, props.children));
};
var OwnUpIconTooltipTriggerBodyRegular = function OwnUpIconTooltipTriggerBodyRegular(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpIconTooltipTriggerImpl, _rollupPluginBabelHelpers._extends({}, props, {
    icon: largeIcon
  }), /*#__PURE__*/React__default['default'].createElement(element.OwnUpBody, {
    variant: "body1"
  }, props.children));
};
var OwnUpIconTooltipTriggerSmallBodyMedium = function OwnUpIconTooltipTriggerSmallBodyMedium(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpIconTooltipTriggerImpl, _rollupPluginBabelHelpers._extends({}, props, {
    icon: smallIcon
  }), /*#__PURE__*/React__default['default'].createElement(element.OwnUpSmallBodyMedium, {
    variant: "body1"
  }, props.children));
};
var OwnUpIconTooltipTriggerSmallBodyRegular = function OwnUpIconTooltipTriggerSmallBodyRegular(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpIconTooltipTriggerImpl, _rollupPluginBabelHelpers._extends({}, props, {
    icon: smallIcon
  }), /*#__PURE__*/React__default['default'].createElement(element.OwnUpSmallBody, {
    variant: "body1"
  }, props.children));
};
var largeIconAccent = /*#__PURE__*/React__default['default'].createElement(iconButtons.OwnUpIconButtonAccent, {
  icon: iconLibrary_systemIcons_microIcons_question.MicroQuestionIcon,
  name: "Tooltip",
  "aria-label": 'tooltip',
  size: 1.25,
  title: "" // Do not use the name for the title attribute on the base element (button).
});
var smallIconAccent = /*#__PURE__*/React__default['default'].createElement(iconButtons.OwnUpIconButtonAccent, {
  icon: iconLibrary_systemIcons_microIcons_question.MicroQuestionIcon,
  name: "Tooltip",
  "aria-label": 'tooltip',
  size: 1.125,
  title: "" // Do not use the name for the title attribute on the base element (button).
});
var OwnUpIconTooltipTriggerBodyMediumAccent = function OwnUpIconTooltipTriggerBodyMediumAccent(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpIconTooltipTriggerImpl, _rollupPluginBabelHelpers._extends({}, props, {
    icon: largeIconAccent
  }), /*#__PURE__*/React__default['default'].createElement(element.OwnUpBodyMedium, {
    variant: "body1"
  }, props.children));
};
var OwnUpIconTooltipTriggerBodyRegularAccent = function OwnUpIconTooltipTriggerBodyRegularAccent(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpIconTooltipTriggerImpl, _rollupPluginBabelHelpers._extends({}, props, {
    icon: largeIconAccent
  }), /*#__PURE__*/React__default['default'].createElement(element.OwnUpBody, {
    variant: "body1"
  }, props.children));
};
var OwnUpIconTooltipTriggerSmallBodyMediumAccent = function OwnUpIconTooltipTriggerSmallBodyMediumAccent(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpIconTooltipTriggerImpl, _rollupPluginBabelHelpers._extends({}, props, {
    icon: smallIconAccent
  }), /*#__PURE__*/React__default['default'].createElement(element.OwnUpSmallBodyMedium, {
    variant: "body1"
  }, props.children));
};
var OwnUpIconTooltipTriggerSmallBodyRegularAccent = function OwnUpIconTooltipTriggerSmallBodyRegularAccent(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpIconTooltipTriggerImpl, _rollupPluginBabelHelpers._extends({}, props, {
    icon: smallIconAccent
  }), /*#__PURE__*/React__default['default'].createElement(element.OwnUpSmallBody, {
    variant: "body1"
  }, props.children));
};

exports.OwnUpIconTooltipTriggerBodyMedium = OwnUpIconTooltipTriggerBodyMedium;
exports.OwnUpIconTooltipTriggerBodyMediumAccent = OwnUpIconTooltipTriggerBodyMediumAccent;
exports.OwnUpIconTooltipTriggerBodyRegular = OwnUpIconTooltipTriggerBodyRegular;
exports.OwnUpIconTooltipTriggerBodyRegularAccent = OwnUpIconTooltipTriggerBodyRegularAccent;
exports.OwnUpIconTooltipTriggerImpl = OwnUpIconTooltipTriggerImpl;
exports.OwnUpIconTooltipTriggerSmallBodyMedium = OwnUpIconTooltipTriggerSmallBodyMedium;
exports.OwnUpIconTooltipTriggerSmallBodyMediumAccent = OwnUpIconTooltipTriggerSmallBodyMediumAccent;
exports.OwnUpIconTooltipTriggerSmallBodyRegular = OwnUpIconTooltipTriggerSmallBodyRegular;
exports.OwnUpIconTooltipTriggerSmallBodyRegularAccent = OwnUpIconTooltipTriggerSmallBodyRegularAccent;
exports.OwnUpUnderlineTooltipTrigger = OwnUpUnderlineTooltipTrigger;
//# sourceMappingURL=icon-tooltip-trigger-4a262641.js.map
